const state = {
  visibleConfWindow: false,
  graphsConfWindow: [],
  widthConfWindow:0,
  heightConfWindow:0,
  currentGraphConfWindow:'',
  errorMssgConfWindow:'',
  initReqConfWindow: [],
}

const getters = {
  isVisibleConfWindow: state => state.visibleConfWindow,
  getGraphsConfWindow: state => state.graphsConfWindow,
  getWidthConfWindow: state => state.widthConfWindow,
  getHeigthConfWindow: state => state.heightConfWindow,
  getCurrentGraphConfWindow: state => state.currentGraphConfWindow,
  getErrorMssgConfWindow: state => state.errorMssgConfWindow,
  getInitReqConfWindow: state => state.initReqConfWindow
}

const actions = {
  setGraphsConfWindow ({ commit }, newGraphsWindow) {
    commit('SET_GRAPHS_CONF_WINDOW', newGraphsWindow)
    commit('SET_VISIBLE_CONFIG_WINDOW', newGraphsWindow.length>0)
  },
  setVisibleConfWindow ({ commit }, newVisGraphsWindow) {
    commit('SET_VISIBLE_CONFIG_WINDOW', newVisGraphsWindow)
  },
  setSizeWindow({ commit }, {newWidth, newHeight}) {
    commit('SET_WIDTH_CONFIG_WINDOW', newWidth)
    commit('SET_HEIGHT_CONFIG_WINDOW', newHeight)
  },
  setCurrentGraphConfWindow({ commit }, newGraph) {
    commit('SET_CURRENT_GRAPH_CONFIG_WINDOW', newGraph)
  },
  setErrorMssgConfWindow({ commit }, errorText) {
    commit('SET_ERROR_MESSAGE_CONFIG_WINDOW', errorText)
  },
  showErrorConfWindow({ commit }, errorText){
    commit('SET_ERROR_MESSAGE_CONFIG_WINDOW', errorText)
    commit('SET_CURRENT_GRAPH_CONFIG_WINDOW', 'ERROR')
  },
  resetInitReqConfWindow({ commit }){
    commit('SET_INIT_REQ_CONF_WINDOW', [])
  },
  removeFromInitReqConfWindow({ commit, state }, graphRemove){
    const indx = state.initReqConfWindow.findIndex(initConf => (initConf.type === graphRemove.type && initConf.study === graphRemove.study))
    if(indx !== -1)
      commit('REMOVE_FROM_INIT_REQ_CONF_WINDOW', indx);
  },
  addInitReqConfWindow({ commit }, initGraph){
    commit('ADD_TO_INIT_REQ_CONF_WINDOW', initGraph)
  },
}

const mutations = {
  SET_GRAPHS_CONF_WINDOW: (state, newGraphsWindow) => (state.graphsConfWindow = newGraphsWindow),
  SET_VISIBLE_CONFIG_WINDOW: (state, newVisGraphsWindow) => (state.visibleConfWindow = newVisGraphsWindow),
  SET_WIDTH_CONFIG_WINDOW: (state, newWidth) => (state.widthConfWindow = newWidth),
  SET_HEIGHT_CONFIG_WINDOW: (state, newHeight) => (state.heightConfWindow = newHeight),
  SET_CURRENT_GRAPH_CONFIG_WINDOW:(state,newGraph) => (state.currentGraphConfWindow = newGraph),
  SET_ERROR_MESSAGE_CONFIG_WINDOW:(state,errorText) => (state.errorMssgConfWindow = errorText),
  SET_INIT_REQ_CONF_WINDOW: (state, initGraphs) => (state.initReqConfWindow = initGraphs),
  ADD_TO_INIT_REQ_CONF_WINDOW: (state, initGraph) => (state.initReqConfWindow.push(initGraph)),
  REMOVE_FROM_INIT_REQ_CONF_WINDOW: (state, indx) => (state.initReqConfWindow.splice(indx, 1)),
}

export default {
  state,
  getters,
  actions,
  mutations
}